import { render, staticRenderFns } from "./yhx.vue?vue&type=template&id=58f5a586&scoped=true&"
import script from "./yhx.vue?vue&type=script&lang=js&"
export * from "./yhx.vue?vue&type=script&lang=js&"
import style0 from "./yhx.vue?vue&type=style&index=0&id=58f5a586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f5a586",
  null
  
)

export default component.exports